<template>
    <div class="normal">
      <BannerImg
        bannerPosition="PTZX_BANNER"
        :showZiXun="false"
        :sub-list="subList"
        :onSublist="handleDetailsClick"
        :title="titleData.title"
        :subTitle="titleData.subTitle"
      />
      <!--    <div class="details-banner" v-if="!bannerImg">-->
      <!--      <div class="details-intro">-->
      <!--        <el-row>-->
      <!--          <el-col :span="24">-->
      <!--            <div class="title">{{ title }}</div>-->
      <!--          </el-col>-->
      <!--          <el-col :xs="24" :md="16" :lg="18">-->
      <!--            <div class="subtitle">{{ subtitle }}</div>-->
      <!--          </el-col>-->
      <!--        </el-row>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <img :src="bannerImg" style="width: 100%;margin-top: 64px" v-if='sourceType === "img" && bannerImg' />-->
      <!--    <video id="" autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto;;margin-top: 64px"-->
      <!--      v-if='sourceType === "video" && video'>-->
      <!--      <source type="video/mp4" :src="video" />-->
      <!--    </video>-->
      <!-- <BannerImg  bannerPosition='PTZX_BANNER' :showZiXun="false" :title="title" :subTitle="subtitle" :sub-list="subList" :onSublist="handleDetailsClick" /> -->
      <div class="details-container m-auto isolate">
        <div class="contant">
          <el-row
            v-for="(item, index) in list"
            :key="index"
            :gutter="20"
            style="
              margin-top: 20px;
              padding-bottom: 20px;
              border-bottom: 1px solid #a9a9a92e;
            "
          >
            <el-col :xs="24" :md="5">
              <img :src="item.thumbnail" style="width: 240px; height: 135px; object-fit: cover;" />
            </el-col>
            <el-col class="contant-right">
              <div @click="handleDetailsClick(item)">
                <div
                  class="title"
                  style="color: #131415; font-size: 20px; font-weight: 700"
                >
                  {{ item.title }}
                </div>
                <div class="desc" style="height: 70px">
                  {{ item.riefIntroduction }}
                </div>
                <span class="time">{{ item.createTime.substring(0, 11) }}</span>
              </div>
            </el-col>
          </el-row>
          <!--        <el-tabs v-model="activeName" @tab-click="getList">
            <el-tab-pane label="平台资讯" name="PT_CONSULT">
              <el-empty v-if="!list.length" description="暂无资讯"></el-empty>
              <el-row v-for="(item, index) in list" :key="index" :gutter="20" style="margin-top: 40px">
                <el-col :xs="24" :md="6">
                  <img :src="item.thumbnail" style="width: 100%">
                </el-col>
                <el-col :xs="24" :md="18" class="contant-right">
                  <div @click="handleDetailsClick(item)">
                    <div class="title">{{ item.title }}</div>
                    <div class="desc">{{ item.riefIntroduction }}</div>
                    &lt;!&ndash; <span class="time">{{ item.time }}</span> &ndash;&gt;
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="行业新闻" name="PT_NEWS">
              <el-empty v-if="!list.length" description="暂无新闻"></el-empty>
              <el-row v-for="(item, index) in list" :key="index" :gutter="20" style="margin-top: 40px">
                <el-col :xs="24" :md="6">
                  <img :src="item.thumbnail" style="width: 100%">
                </el-col>
                <el-col :xs="24" :md="18" class="contant-right">
                  <div @click="handleDetailsClick(item)">
                    <div class="title">{{ item.title }}</div>
                    <div class="desc">{{ item.riefIntroduction }}</div>
                    &lt;!&ndash; <span class="time">{{ item.time }}</span> &ndash;&gt;
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>-->
          <div>
            <el-pagination
              background
              hide-on-single-page
              :page-size.sync="queryParams.pageSize"
              :current-page.sync="queryParams.pageNum"
              layout="prev, pager, next"
              :total="total"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
    </div>
  </template>

  <script>
  import { getConsultList } from "@/api/consult";
  import { listBanner } from "@/api";
  import BannerImg from "@/components/BannerImg.vue";
  export default {
    name: "information",
    components: { BannerImg },
    data() {
      return {
           // 返回顶部按钮
      showButton: false,
        activeName: "PT_CONSULT",
        titleData: {},
        bannerImg: "",
        list: [],
        video: "",
        bannerPath: "",
        total: undefined,
        queryParams: {
          articleType: undefined,
          pageNum: 1,
          pageSize: 3,
          showStatus: '1',
        },
        subList: [],
        // sourceType: 'img',
        // bannerImg: ''
      };
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    mounted() {
      this.getList();
      // 获取banner数据
      // this.getBanner()
      window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
      totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {
      this.showButton = window.scrollY > 200;
    },
      async getBanner() {
        const res = await listBanner({
          bannerPosition: "PTZX_BANNER",
          useFlag: "1",
        });
        const data = res.rows.find(
          (v) =>
            (v.bannerImg && v.sourceType == "img") ||
            (v.video && v.sourceType == "video")
        );
        if (!data) return;
        this.sourceType = data.sourceType;
        this.bannerImg = data.bannerImg;
        this.video = data.video;
        this.bannerPath = data.link;
      },
      getList() {
        this.queryParams.articleType = this.activeName;
        console.log(this.queryParams, "@@@@@@@@@")
        getConsultList(this.queryParams).then((res) => {
          this.list = res.rows;
          if (this.subList.length == 0) {
            this.subList = res.rows
              .slice(0, 3)
              .map((x) => ({
                ...x,
                title: x.title,
                subTitle: x.riefIntroduction,
                img: x.thumbnail,
              }));
          }
          this.total = res.total;
        });
      },
      handleDetailsClick(item) {
        this.$router.push({
          path: "/ConsultDetails",
          query: { id: item.id, name: this.activeName },
        });
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val;
        this.getList();
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  .to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
  .details-container {
    width:1280px;
    margin:0 auto;
  }
  .el-pagination {
    text-align: center;
    margin-top: 60px;
    margin-bottom: 100px;
  }

  //.details-banner {
  //  /* width: 100%;
  //  height: 450px;
  //  background: #20252f;
  //  position: relative; */
  //
  //  .details-intro {
  //    width: 75%;
  //    position: absolute;
  //    top: 40%;
  //    left: 12%;
  //    color: #ffffff;
  //
  //    .title {
  //      font-size: 36px;
  //      font-weight: 500;
  //      margin-bottom: 15px;
  //    }
  //
  //    .subtitle {
  //      opacity: 0.8;
  //      font-size: 16px;
  //      font-weight: 400;
  //      line-height: 28px;
  //    }
  //  }
  //}

  .details-container {
    margin-top: 210px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .contant {
      width: 100%;
      margin-top: 60px;

      .el-row{
        display: flex;
      justify-content: flex-start;
        cursor: pointer;
        &:hover .title {
        color: #e50009 !important;
      }
      }
      .contant-right {
        cursor: pointer;

        .title {
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 10px;
          font-style: normal;
          line-height: normal;
        }

        .desc {
          font-size: 14px;
          color: rgba(19, 20, 21, 0.60);
          margin-bottom: 10px;

          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        .time {
          font-size: 14px;
          font-weight: 500;
          color: rgba(19, 20, 21, 0.60);
        }

        &:hover {
          color: #E50009;
        }
      }
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/zixun.vue